import styled, { createGlobalStyle } from 'styled-components';
import { token } from '@zillow/constellation';

export const AppContainer = styled.div`
    height: 100%;
    min-height: 100vh;
    width: 100%;
    background-color: ${token('colors.gray200')};
`;

export const FooterContainer = styled.div`
    min-width: 100%;
    background-color: ${token('colors.white')};
`;

export const ResetStyles = createGlobalStyle`
    body,
    div,
    dl,
    dt,
    dd,
    ul,
    ol,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    pre,
    code,
    form,
    fieldset,
    legend,
    input,
    textarea,
    p,
    blockquote,
    th,
    td {
        margin: 0;
        padding: 0;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    fieldset,
    img {
        border: 0;
    }

    strong {
        font-style: normal;
        font-weight: bold;
    }

    address,
    caption,
    cite,
    code,
    dfn,
    em,
    th,
    var {
        font-style: normal;
        font-weight: normal;
    }

    ol,
    ul {
        list-style: none;
    }

    caption,
    th {
        text-align: left;
    }

    q:before,
    q:after {
        content: '';
    }

    abbr,
    acronym {
        border: 0;
        font-variant: normal;
    }

    sub {
        vertical-align: text-bottom;
    }

    input,
    textarea,
    select {
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
    }

    input,
    textarea,
    select {
        font-size: 100%;
    }

    *,
    *:before,
    *:after {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    button {
        margin: 0px;
        border: none;
    }

    iframe {
        border: none;
    }
`;

export const GlobalStyle = createGlobalStyle`
    body {
        font-family:"Open Sans";
    }
`;
